import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Headset, User } from '@phosphor-icons/react';
import { Logo } from './Logo';

interface LandingHeaderProps {
  color?: '#FFFFFF' | '#361E06';
}

export function LandingHeader({ color = '#FFFFFF' }: LandingHeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 h-[60px] z-50">
      <div className="h-full w-full px-4 flex items-center justify-between">
        <div 
          onClick={() => navigate('/support')}
          className="p-2 hover:bg-[rgba(0,0,0,0.05)] rounded-lg cursor-pointer"
        >
          <Headset 
            size={24} 
            className={color === '#FFFFFF' ? 'text-[#FFFFFF]' : 'text-[#361E06]'} 
            weight="bold" 
          />
        </div>

        <div 
          onClick={() => navigate('/')}
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
        >
          <Logo 
            size={32} 
            className={color === '#FFFFFF' ? 'text-[#FFFFFF]' : 'text-[#361E06]'} 
          />
        </div>

        <div 
          onClick={() => navigate('/login')}
          className="p-2 hover:bg-[rgba(0,0,0,0.05)] rounded-lg cursor-pointer"
        >
          <User 
            size={24} 
            className={color === '#FFFFFF' ? 'text-[#FFFFFF]' : 'text-[#361E06]'} 
            weight="bold" 
          />
        </div>
      </div>
    </header>
  );
} 